import React, { useEffect, useState, useMemo } from 'react';
import { Routes, Route, NavLink, useLocation } from 'react-router-dom';

import { onSaveFunction } from './api/dataService.js';
import { handleOAuthRedirect, processLogout } from './api/authService.js';

import PopupModal from './components/PopupModal';
import './styles/main.css';
import { Icon } from './styles/icons.js' ;
import { AppActionList, TabList } from './config/fieldsConfig.js';
import logo from './cast-n-track-logo-removebg.png' ;


function openHelpFor(activeTab) {
  // single help file - jump to relevant section
  const helpLinks = `https://cast-n-track.online/cast-n-track-help.html#${activeTab}`
  window.open(helpLinks, '_blank');
}

function getThatMoney() { 
  console.log( 'Triggering Contribute Screen' ) ;
  // TODO get money!
}

function updatePreferences() { 
  console.log( 'Triggering Settings Screen' ) ;
  // TODO Settings
}



function App() {

  useEffect(() => { handleOAuthRedirect() }, []) ;

  const [selectedRecord, setSelectedRecord] = useState(null);
  const [modalMode, setModalMode] = useState("view");

  // triggerRefresh function... uses refreshKey and does not need activeTab
  const [refreshKey, setRefreshKey] = useState(0) ;
  const triggerTabRefresh = () => setRefreshKey( prev => prev+1) ; 

  const pathToActiveTabMap = useMemo(() => {
    const map = {} ;
    Object.entries(TabList).forEach(([key,tab]) => { map[tab.path] = key ; } );
    return map ;
  }, [] ) ;
  
  const [activeTab, setActiveTab] = useState("dashboard") ;
  const location = useLocation() ;

  useEffect(() => { setActiveTab( pathToActiveTabMap?.[location.pathname] || "dashboard" ) }, [location, pathToActiveTabMap] ) ;

  const renderModal = () => {
    console.log('Entered renderModal:',activeTab,selectedRecord,modalMode ) ;

    if (!selectedRecord) return null;

    const dataType = selectedRecord.dataType || activeTab; // use activeTab as fallback
    let config = TabList?.[dataType]?.fields;
    console.log( 'calculated config:', config ) ;
    if (!config) return null;

    const onClose = () => {
      setSelectedRecord(null);
      setModalMode("view");
    };

    function onModeChange(newMode) { setModalMode(newMode) ;}

    return (
      <PopupModal
        mode={modalMode}
        record={selectedRecord}
        config={config}
        onClose={onClose}
        onSave={async (record) => { 
          console.log("App.js/renderModal - Saving record:", record );
          await onSaveFunction( dataType, modalMode, record ) ;
          triggerTabRefresh();
          // onClose() is now handled inside PopupModal on success
        }} 
        onModeChange={onModeChange}
      />
    );
  };

  const handleNewRecord = () => {
    console.log('Triggering new record for tab:', activeTab);
    setSelectedRecord( TabList[activeTab].createRecordDefaults ) ;
    setModalMode("create");
    renderModal() ;
  }

  const handleOnClick = (button) => {
    switch (button) {
      case "create": handleNewRecord(activeTab) ; break;
      case "refresh": triggerTabRefresh(activeTab) ; break;
      case "help": openHelpFor(activeTab) ; break;
      case "contribute": getThatMoney() ; break;
      case "preferences": updatePreferences() ; break;
      case "logout": processLogout() ; break;
      default: break;
    }
  }

  return (
    <div> 
      <div className="navbar">
        <div className="nav-left">
          <img src={logo} alt="Cast & Track" className="logo" />
          {Object.entries(TabList).map(([key, tab]) => {
            return( 
              <NavLink key={key} to={tab.path} className="nav-item">
                {Icon(key)} 
                {tab.label}
              </NavLink>
            ) ;
          })}
        </div>
        <div className="nav-right">
          {Object.entries(AppActionList).map(([key,action]) => {
            if (activeTab === "dashboard" && key === "create") return null; //skip create key if activeTab is dashboard
            return ( <button key={key} className="icon-button" title={action.tooltip} onClick={() => handleOnClick(key)} > {Icon(key)} </button> )
          })}
        </div>
      </div>
      <Routes>
        {Object.entries(TabList).map(([key, tab]) => {
          const Component = tab.uiComponent ;
          return( <Route path={tab.path} key={key}
            element={<Component dataType={key} tab={tab}  
              setSelectedRecord={setSelectedRecord} setModalMode={setModalMode} refreshKey={refreshKey} triggerTabRefresh={triggerTabRefresh}
            />} 
          /> ) ;
        })}
      </Routes>
      {renderModal()}
    </div> 
  );
}

export default App;

